// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__38_TU","dragIcon":"SortableItem_dragIcon__1Hp1M","disabled":"SortableItem_disabled__1wEgj"};